import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const BrandingContext = createContext(null);
export function BrandingProvider({ branding, children, }) {
    return (_jsx(BrandingContext.Provider, { value: branding, children: children }));
}
export function useBranding() {
    return useContext(BrandingContext);
}
//# sourceMappingURL=BrandingContext.js.map